import { logged, page } from './stores'

export function getPgCount(articles) {
  let count = 0

  for (let i=0; i<articles.length; i++) {
    let groups = articles[i].groups
    
    for (let j=0; j<groups.length; j++) {
      if (groups[j].page > count) count = groups[j].page
    }
  }
  console.log('getPgCount', count)
  return count
}

export function setUrl(id, page, pagenum) {
  history.replaceState({id, page, pagenum}, '', '/?id=' + encodeURIComponent(id) + '&pg=' + pagenum)
}

export async function getArticles(issueId, index) {
  try {
    const res = await fetch('/article/' + issueId + '/' + index)
    console.log('fetch', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { error: res?.statusText, data: null }

    const tmp = await res.json()
    console.log('getArticles', tmp)
    if (tmp.msg) return { error: tmp.msg }
    if (tmp.message) return { error: tmp.message } // elastic
    
    const articles = tmp?.length ? tmp : null 
    return { data: articles }
  } catch (e) {
    console.log('catch getArticles', e);
    return { error: e, data: null}
  }
}

export async function setArticles(articles, issueId, index) {
  try {
    const res = await fetch ('/article/' + issueId + '/' + index, {
      method: 'PUT', 
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(articles) 
    })
    console.log('setArticles1', res)
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return res?.statusText

    const tmp = await res.json()
    console.log('setArticles', tmp, tmp?.ok)
    if (tmp.msg) return tmp.msg
    if (tmp.message) return tmp.message // elastic
    if (tmp?.ok) { return '' } else { return 'chyba v setArticles'}
  } catch (e) {
    console.log('catch setArticles', e);
    return e
  }
}

export async function doLogin(name, payload) {
  try {
    const res = await fetch ('/login', {
      method: 'POST',      
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({name, payload})
    })
    const tmp = await res.json()
    console.log('login', tmp)
    if (tmp.ok) {
      logged.set(tmp.user)
    } else {
      logged.set(null)
    }
    // return tmp.user
  } catch (e) {
    console.log('catch doLogin', e);
    return e
  }
}

export async function getKramerius(uuid, server) {
  try {
    const pars = new URLSearchParams()
    pars.append('uuid',uuid);
    pars.append('server',server);

    const res = await fetch('/parsing/checkUuid/?' + pars.toString().replaceAll('+','%20'))
    console.log('getKram1', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { msg: res?.statusText }

    const tmp = await res.json()
    console.log('getKram2', tmp)

    return tmp
  } catch (e) {
    console.log('catch getKramerius', e);
    return { msg: e }
  }
}

function collect(from, to) {
  for (const item of from) {
    if (!item.canProcess) to.push(item.uuid)
    if (item.children) collect(item.children, to)
  }
}

export async function setKramerius(obj, timeToExecute, description, user, mode) {
  try {
    const ignoredUuids = []
    collect(obj.children, ignoredUuids)
    
    const d = new Date()
    const objret = {
      description,
      krameriusUuid: obj.uuid,
      createdAt: `${d.getDate()}.${('0'+(d.getMonth()+1)).slice(-2)}.${d.getFullYear()} ${('0'+d.getHours()).slice(-2)}:${('0'+d.getMinutes()).slice(-2)}:${('0'+d.getSeconds()).slice(-2)}`,
      processAt: '',
      timeToExecute,    
      user,
      ignoredUuids,
      name : obj.name,
      status: 'Planned',
      error: '',
      mode
    }
    console.log('setKramerius0', objret);
    
    const res = await fetch ('/parsing', {
      method: 'POST', 
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(objret) 
    })
    console.log('setKramerius1', res)
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { msg: res?.statusText }
    
    const tmp = await res.json()
    console.log('setKramerius', tmp, tmp?.ok)
    
    return tmp?.ok
  } catch (e) {
    console.log('catch getKramerius', e);
    return { msg: e }
  }
}

export async function getTasks() {
  try {
    const res = await fetch('/parsing')
    console.log('getTasks1', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { msg: res?.statusText }

    const tmp = await res.json()
    console.log('getTasks2', tmp)

    return tmp
    } catch (e) {
    console.log('catch getKramerius', e);
    return { msg: e }
  }
}

export async function getParsedIssues(journalName, status, user) {
  try {
    const pars = new URLSearchParams()
    if (journalName && journalName!=='') pars.append('journalName', journalName);
    if (status && status!=='') pars.append('status', status);
    if (user) pars.append('user', user);
    const res = await fetch('/getParsedIssues?' + pars.toString().replaceAll('+','%20'));

    console.log('getParsedIssues1', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { error: res?.statusText, data: null }

    const tmp = await res.json()
    console.log('getParsedIssues2', tmp)

    if (tmp.msg) return { error: tmp.msg }
    if (tmp.message) return { error: tmp.message } // elastic
    return { data: tmp }
  }  catch (e) {
    console.log('catch getParsedIssues', e);
    return { error: e, data: null}
  }
}

export async function getIssue(issueId) {
  try {
    const res = await fetch('/issue/' + issueId)
    console.log('getIssue1', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { error: res?.statusText, issue: null }

    let tmp = await res.json()
    if (tmp.msg) return { error: tmp.msg }
    if (tmp.message) return { error: tmp.message } // elastic
    tmp.id = issueId
    console.log('getIssue2', tmp)

    if (tmp.state === 'downloaded' || tmp.state === 'proheadings' || tmp.state === 'headings') {
      page.set('heading');
    } 
    else if (tmp.state === 'blocks' || tmp.state === 'cleaning' || tmp.state === 'cleaned') {
      page.set('clean');
    } 
    else if (tmp.state === 'articles' || tmp.state === 'checking' || tmp.state === 'checked') {
      page.set('check');
    }

    return { issue: tmp }
  } catch (e) {
    console.log('catch getIssue', e);
    return { error: e, issue: null}
  }
}

export async function setState(issueId, state, user) {
  try {
    const obj = {
      id: issueId,
      lastChange: user,
      state
    }
    const res = await fetch ('/issue', {
      method: 'PUT', 
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(obj) 
    })
    console.log('setState1', res)
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return res?.statusText

    const tmp = await res.json()
    console.log('setState', tmp, tmp?.ok)
    if (tmp.msg) return tmp.msg
    if (tmp.message) return tmp.message // elastic
    if (tmp?.ok) { return '' } else { return 'chyba v setState'}
  } catch (e) {
    console.log('catch setState', e);
    return e
  }
}

export async function getPeriodicals() {
  try {
    const res = await fetch('/getlistOfPeriodicals');

    console.log('getPeriodicals1', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { error: res?.statusText, periodicals: null }

    const tmp = await res.json()
    console.log('getPeriodicals2', tmp);
    if (tmp.msg) return { error: tmp.msg }
    if (tmp.message) return { error: tmp.message } // elastic

    const ret = []
    for (const x of tmp) {
      ret.push({item: x})
    }
    return { periodicals: ret }
  } catch (e) {
    console.log('catch getPeriodicals', e);
    return { error: e, periodicals: null}
  }
}

export async function createArticle() {
  try {
    const res = await fetch ('/article', {
      method: 'POST',      
      headers: {'Content-Type': 'application/json'}
      // body: "{}"
    })
    console.log('createArticle1', res)
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { error: res?.statusText, id: null }

    const tmp = await res.json()
    console.log('createArticle', tmp)
    if (tmp.msg) return { error: tmp.msg }
    if (tmp.message) return { error: tmp.message } // elastic
    return { id: tmp.articleID }
  } catch (e) {
    console.log('catch createArticle', e);
    return { error: e, id: null}
  }
}

export async function getLinesForBlock(issueId, block) {
  try {
    const pars = new URLSearchParams()
    pars.append('issueId',issueId);
    pars.append('block',JSON.stringify(block));
    const res = await fetch('/getLinesForBlock?' + pars.toString().replaceAll('+','%20'))

    console.log('getLinesForBlock1', res)  
    if (res?.status === 401) logged.set(false)
    if (!res?.ok) return { msg: res?.statusText }

    const tmp = await res.json()
    console.log('getLinesForBlock2', tmp)

    return tmp
  } catch (e) {
    console.log('catch createArticle', e);
    return { msg: e }
  }
}

  export async function splitBlock(articleId, block, line) {
    try {
      const pars = new URLSearchParams()
      pars.append('articleId',articleId);
      pars.append('block',JSON.stringify(block));
      pars.append('line',JSON.stringify(line));
      const res = await fetch('/splitBlock?' + pars.toString().replaceAll('+','%20'))

      console.log('splitBlock1', res)  
      if (res?.status === 401) logged.set(false)
      if (!res?.ok) return { msg: res?.statusText }
    
      const tmp = await res.json()
      console.log('splitBlock2', tmp)
    
      // if (tmp?.ok) { return '' } else { return 'chyba v splitBlock'}
      return tmp
    } catch (e) {
      console.log('catch splitBlock', e);
      return { msg: e }
    }
  }